<template>
  <v-row no-gutters class="fill-height">
    <v-col cols="12">
      <main-loader v-if="isLoading" class="pt-10" />
      <template v-else>
        <card-title-row
          class="pt-8"
          is-floating
          :feature-title="title"
          :has-back-button="true"
          :has-icon-column="true"
          :has-tools-buttons="true"
          @action="goBack"
        >
          <template #toolsButtons>
            <v-row>
              <!-- showHistory, showNotes, showAttachments nie może zostać przeniesiony do feature-card-zdm-buttons bo nie ma dostępu do refsów rodzca  -->
              <feature-card-zdm-buttons
                :permissions="extrasPermission"
                :geometry="geometry"
                @showHistory="showExtrasTab('history')"
                @showNotes="showExtrasTab('notes')"
                @showAttachments="showExtrasTab('attachments')"
                @showRelations="showExtrasTab('relations')"
                @external_systems="openZSIDialog"
                :layer-id="layerId"
                :dataSource="dataSource"
                :feature-id="featureId"
                :number-attribute-value="numberAttributeValue"
                :street-attribute-value="streetAttributeValue"
                :district-attribute-value="districtAttributeValue"
                :featureProps="feature.properties"
              ></feature-card-zdm-buttons>
            </v-row>
          </template>
        </card-title-row>
        <sidebar-row class="pt-8 pb-5 pr-5" :border-bottom="true">
          <lamp-treeview
            :badge-translation="badgeTranslation"
            :is-editing-on="isEditingOn"
            @edit="startEditing"
            @delete="onDelete"
            @addSubfeature="openAddDialog"
            :featureId="featureId"
            :structure="treeviewStructure"
            v-model="activeFeature"
            :streetLampDatasource="zdmCabinetDataSourceName"
          ></lamp-treeview>
        </sidebar-row>
        <v-form v-model="isFormValid">
          <!-- <sidebar-form-row
            v-if="type !== MAIN_TYPE"
            :is-editing-on="isEditingOn"
            v-bind="typeAttribute"
            v-model="values[typeAttribute.name]"
            class="pt-5"
          >
          </sidebar-form-row> -->
          <feature-card-data
            :elements="formSchema"
            v-model="values"
            :is-editing-on="isEditingOn"
            :layer-id="subFeatureLayerId"
            arrows-mode="on-with-storage"
            :dense="true"
            :outlined="true"
            align-class="align-baseline"
          />
        </v-form>
        <object-extras
          ref="extras"
          v-if="!isNew"
          :layerId="layerId"
          :featureId="featureId"
          :subFeatureId="subFeatureId"
          :dataSourceName="dataSource"
          :subDataSourceName="subFeatureDataSourceName"
          :permissions="extrasPermission"
          :geometry="geometry"
        ></object-extras>
      </template>
      <main-dialog
        :is-visible.sync="isMainDialogVisible"
        v-if="isMainDialogLoaded"
        :title="mainDialogTitle"
        :body="mainDialogBody"
        :agree-text="mainDialogAgree"
        @agree="mainDialogAction"
        :loading="mainDialogButtonLoading"
      ></main-dialog>
      <external-systems-dialog
        :is-visible.sync="isZSIDialogVisible"
        v-if="isZSIDialogLoaded"
        :feature-id="featureId"
        :system-id="datasourceSystemId"
        :datasource="dataSource"
      />
      <!-- <main-input-dialog
        v-if="isAddSubfeatureDialogLoaded"
        :is-visible.sync="isAddSubfeatureDialogVisible"
        :title-translation="addSubfeatureDialogTitle"
        agree-text="dialog.agreeAdd"
        :is-input-dialog="true"
        @agree="handleSubfeatureAdding"
        :inputs="[addedObjectInputConfig]"
        :loading="addSubfeatureButtonLoading"
      >
        <template #type.input="slot">
          <v-row no-gutters>
            <v-col>
              <data-input v-bind="slot" v-model="addedObject.type" clearable> </data-input>
            </v-col>
          </v-row>
        </template>
      </main-input-dialog> -->
    </v-col>
  </v-row>
</template>

<script>
import { get, sync, call } from 'vuex-pathify';
import { cloneDeep } from 'lodash';

import { prepareDrawnGeometry } from '@/assets/js/mapUtils';

import prepareAttributesFeatureCardMixin from '@/mixins/prepareAttributesFeatureCardMixin';
import fetchAttributesSchemaMixin from '@/mixins/fetchAttributesSchemaMixin';
import featureCardHighlight from '@/mixins/featureCardHighlight';
import featureCardZdmButtonsMixin from '@/mixins/featureCardZdmButtonsMixin';

import LampTreeview from '@/components/LampTreeview';
import CardTitleRow from '@/components/CardTitleRow';
import MainLoader from '@/components/MainLoader';
import SidebarRow from '@/components/SidebarRow';
import ObjectExtras from '@/components/ObjectExtras';
import FeatureCardData from '@/components/FeatureCardData';
import FeatureCardZdmButtons from '@/components/FeatureCardZdmButtons';
// import SidebarFormRow from '@/components/SidebarFormRow';
// import DataInput from '@/components/DataInput';

const MAIN_TYPE = 'cabinet';

export default {
  name: 'FeatureCardZdmCabinet',
  mixins: [
    featureCardHighlight,
    fetchAttributesSchemaMixin,
    prepareAttributesFeatureCardMixin,
    featureCardZdmButtonsMixin,
  ],
  components: {
    ExternalSystemsDialog: () => import('@/components/ExternalSystemsDialog'),
    LampTreeview,
    CardTitleRow,
    MainLoader,
    SidebarRow,
    ObjectExtras,
    FeatureCardData,
    FeatureCardZdmButtons,
    // SidebarFormRow,
    // DataInput,
    MainDialog: () => import('@/components/MainDialog'),
  },
  props: {
    dataSource: {
      type: String,
      required: true,
    },
    layer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    MAIN_TYPE,
    subFeaturesNamesDict: {
      cabinet: 'circuit',
    },
    isZSIDialogVisible: false,
    isZSIDialogLoaded: false,
    feature: undefined,
    isLoading: true,
    isNew: false,
    formSchema: undefined,
    values: {},
    isFormValid: true,
    isEditingOn: false,
    subfeaturesDict: undefined,
    treeviewStructure: undefined,
    activeFeature: undefined,
    type: undefined,
    // typeAttribute: undefined,

    isMainDialogLoaded: false,
    isMainDialogVisible: false,
    dialogType: undefined,
    mainDialogButtonLoading: false,
    isAddSubfeatureDialogVisible: false,
    isAddSubfeatureDialogLoaded: false,
    addSubfeatureButtonLoading: false,
    addedObject: {
      type: undefined,
      datasource: undefined,
      id: undefined,
    },
  }),
  computed: {
    mapPanelDataFetched: get('map/mapPanelDataFetched'),
    permissions: get('users/layersPermissions'),
    layers: get('layers/layers'),
    relationValuesMapping: get('layers/relationValuesMapping'),

    isStickyButtonsLoading: sync('sidebar/isStickyButtonsLoading'),
    isStickyButtonsValid: sync('sidebar/isStickyButtonsValid'),
    isStickyButtonsVisible: sync('sidebar/isStickyButtonsVisible'),
    stickyButtons: sync('sidebar/stickyButtons'),
    isEditingButtonActive: sync('edit/isEditingButtonActive'),

    geometryPropertyName: get('layers/metadata@:zdmCabinetDataSourceName.attributes_schema.geometry_name'),

    zdmDataDataSources: get('admin/modulesMapping@zdm_data.datasources'),
    zdmCabinetDataSourceName: get('admin/modulesMapping@zdm_data.datasources.cabinet.datasource'),
    circuitDataSourceName: get('admin/modulesMapping@zdm_data.datasources.circuit.datasource'),

    zdmDataLayers: get('admin/modulesMapping@zdm_data.layers'),
    cabinetLayerId: get('admin/modulesMapping@zdm_data.layers.cabinet'),
    circuitLayerId: get('admin/modulesMapping@zdm_data.layers.circuit'),

    cabinetIdPropName: get('layers/metadata@:zdmCabinetDataSourceName.attributes_schema.id_name'),
    circuitIdPropName: get('layers/metadata@:circuitDataSourceName.attributes_schema.id_name'),

    cabinetDisplayedName: get('admin/modulesMapping@zdm_data.datasources.cabinet.display_attribute_name'),
    circuitDisplayedName: get('admin/modulesMapping@zdm_data.datasources.circuit.display_attribute_name'),

    cabinetCatalogAttributeName: get('admin/modulesMapping@zdm_data.datasources.cabinet.catalog_attribute_name'),
    circuitCatalogAttributeName: get('admin/modulesMapping@zdm_data.datasources.circuit.catalog_attribute_name'),
    isDatasourceConnectedToExternalSystem: get('externalSystems/connectedDataSources@:dataSource'),
    isExternalSystemsEnabled: get('admin/settingsValues@external_systems_module_enabled'),
    isNewCard: sync('map/isNewCard'),
    zdmDataSources: get('admin/modulesMapping@zdm_data.datasources'),
    datasourceSystemId() {
      return this.isDatasourceConnectedToExternalSystem?.id;
    },
    subDataSources() {
      return [this.circuitDataSourceName];
    },

    layersIdDict() {
      return {
        [this.zdmCabinetDataSourceName]: this.cabinetLayerId,
        [this.circuitDataSourceName]: this.circuitLayerId,
      };
    },

    idPropNameDict() {
      return {
        [this.zdmCabinetDataSourceName]: this.cabinetIdPropName,
        [this.circuitDataSourceName]: this.circuitIdPropName,
      };
    },

    displayNameDict() {
      return {
        [this.zdmCabinetDataSourceName]: this.cabinetDisplayedName,
        [this.circuitDataSourceName]: this.circuitDisplayedName,
      };
    },

    catalogAttributeNameDict() {
      return {
        [this.zdmCabinetDataSourceName]: this.cabinetCatalogAttributeName,
        [this.circuitDataSourceName]: this.circuitCatalogAttributeName,
      };
    },
    extrasPermission() {
      return this.permissions[this.layerId].attachments_and_comments_value;
    },
    relationalDataSources() {
      return {
        [this.circuitDataSourceName]: 'configuration_id',
      };
    },

    title() {
      return {
        title: this.feature.properties[this.displayNameDict[this.zdmCabinetDataSourceName]],
        subtitle: this.$i18n.t('sidebar.zdmCabinet.title'),
      };
    },
    layerId() {
      return this.layer.id;
    },
    featureId() {
      return this.routeParams.fid;
    },
    subFeatureId() {
      return this.$route.query?.id || null;
    },
    subFeatureType() {
      return this.$route.query?.type || MAIN_TYPE;
    },
    subFeatureLayerId() {
      return this.zdmDataLayers[this.subFeatureType];
    },
    subFeatureDataSourceName() {
      return this.zdmDataDataSources?.[this.subFeatureType]?.datasource || '';
    },
    routeParams() {
      return this.$route.params;
    },
    routeQuery() {
      return this.$route.query;
    },
    mainDialogTitle() {
      const key = this.dialogType === 'delete' ? 'deleteObject' : 'addCircuit';
      return this.$i18n.t(`dialog.title.${key}`);
    },
    mainDialogBody() {
      const key = this.dialogType === 'delete' ? 'deleteObject' : 'addCircuit';
      const id = this.dialogType === 'delete' ? this.deletedId : this.addedObject.id;
      return this.$i18n.t(`dialog.body.${key}`, { id });
    },
    mainDialogAgree() {
      const key = this.dialogType === 'delete' ? 'agreeDelete' : 'agreeAdd';
      return `dialog.${key}`;
    },

    mainDialogAction() {
      return this.dialogType === 'delete' ? this.deleteObjectHandler : this.handleSubfeatureAdding;
    },
    badgeTranslation() {
      return this.$i18n.t('sidebar.zdmLamp.type');
    },
    numberAttributeName() {
      return this.$_objectToArray(this.zdmDataSources).find(d => d.datasource === this.zdmCabinetDataSourceName)
        ?.display_attribute_name;
    },
    streetAttributeName() {
      return this.$_objectToArray(this.zdmDataSources).find(d => d.datasource === this.zdmCabinetDataSourceName)
        ?.street_attribute_name;
    },
    districtAttributeName() {
      return this.$_objectToArray(this.zdmDataSources).find(d => d.datasource === this.zdmCabinetDataSourceName)
        ?.district_attribute_name;
    },
    numberAttributeValue() {
      return this.subfeaturesDict[`${MAIN_TYPE}@${this.featureId}`][this.numberAttributeName];
    },
    streetAttributeValue() {
      return this.subfeaturesDict[`${MAIN_TYPE}@${this.featureId}`][this.streetAttributeName];
    },
    districtAttributeValue() {
      return this.subfeaturesDict[`${MAIN_TYPE}@${this.featureId}`][this.districtAttributeName];
    },
  },
  watch: {
    isFormValid: {
      immediate: true,
      handler(nV) {
        this.isStickyButtonsValid = nV;
      },
    },
  },
  methods: {
    deleteDatasourceFeature: call('layers/deleteDatasourceFeature'),
    getLampWithObjectsAction: call('zdm/getZdmObjectTreeStructure'),
    addNonTopoFeatureAction: call('layers/addDatasourceFeature'),
    editNonTopoFeatureAction: call('layers/editDatasourceFeature'),
    openZSIDialog() {
      this.isZSIDialogLoaded = true;
      this.isZSIDialogVisible = true;
    },
    async editNonTopoFeature() {
      try {
        this.isStickyButtonsLoading = true;
        const { type, currentObjectId: id } = this;
        const currentDatasource = this.getDatasource(type);
        await this.editNonTopoFeatureAction({
          datasource: currentDatasource,
          id,
          body: this.getPayload(type),
          params: { layer_id: this.layersIdDict[currentDatasource] },
        });
        this.stopEditing();
        this.refreshLayersAndTable([this.layerId]);
        await this.init(this.featureId, true);
        this.isStickyButtonsLoading = false;
      } catch (error) {
        console.log(error);
        this.isStickyButtonsLoading = false;
      }
    },
    startEditing(datasource) {
      this.featureCopy = cloneDeep(this.feature);
      this.valuesCopy = cloneDeep(this.values);
      this.geometryCopy = cloneDeep(this.feature.geometry);

      this.isEditingOn = true;
      this.isStickyButtonsVisible = true;
      this.stickyButtons = [
        {
          action: 'featureEditing',
          translationPath: 'dialog.save',
        },
        {
          action: 'cancelEditing',
          translationPath: 'dialog.disagree',
          cancel: true,
        },
      ];
      this.isEditingButtonActive = true;
      if (datasource === this.zdmCabinetDataSourceName) {
        this.$root.$emit('modifySidebarGeometry', {
          geometryValue: this.geometry,
          modifyendCallback: this.onModifyend,
          layerId: this.layerId,
        });
      }
    },
    cancelEditing() {
      this.stopEditing();
      this.feature = cloneDeep(this.featureCopy);
      this.values = cloneDeep(this.valuesCopy);
      this.geometry = cloneDeep(this.geometryCopy);
    },
    stopEditing() {
      this.isEditingOn = false;
      this.isStickyButtonsVisible = false;
      this.isStickyButtonsLoading = false;
      this.stickyButtons = [];
      this.isEditingButtonActive = false;
      this.$root.$emit('selection-action', this.tableSelectionType);
      this.$root.$emit('deleteSidebarGeometry');
    },
    setSidebarGeometry(feature) {
      if (!feature) {
        this.geometry = null;
      } else {
        this.geometry = prepareDrawnGeometry(feature);
      }
    },
    onModifyend(e) {
      this.setSidebarGeometry(e.features.getArray()[0]);
    },
    openAddDialog(id, parentDatasource) {
      this.dialogType = 'addSubfeature';
      // const addedType = parentDatasource === this.circuitDataSourceName ? 'circuit' : 'pick_arm';
      const addedType = 'circuit';
      const addedDatasource = this.getDatasource(addedType);
      // const layer =
      //   parentDatasource === this.zdmCabinetDataSourceName
      //     ? this.layer
      //     : this.layers[this.layersIdDict[addedDatasource]];
      // const layerSchema = layer.form_schema.elements;
      // const catalogAttributeName =
      //   parentDatasource !== this.zdmCabinetDataSourceName && this.catalogAttributeNameDict[addedDatasource];
      // this.addedObjectInputConfig = {
      //   ...this.getTypeAttribute({
      //     datasource: addedDatasource,
      //     layerSchema,
      //     catalogAttributeName,
      //   }),
      //   name: 'type',
      //   rules: [v => !!v || v == '0' || 'rules.required'],
      //   cols: '12',
      // };
      this.addedObject = {
        id,
        parentDatasource,
        addedDatasource,
      };
      this.isMainDialogLoaded = true;
      this.isMainDialogVisible = true;
    },
    getParentIdKey(datasource) {
      return this.idPropNameDict[datasource];
    },
    async handleSubfeatureAdding() {
      try {
        this.mainDialogButtonLoading = true;
        const { id, addedDatasource } = this.addedObject;
        // const catalogAttributeName = this.catalogAttributeNameDict[addedDatasource];
        // const payload =
        //   addedDatasource === 'zdm_data_pick_arm'
        //     ? { 'zdm_data_pick_arm.pole_id': id, [catalogAttributeName]: type, 'zdm_data_pick_arm.main': false }
        //     : { 'zdm_data_head.pick_arm_id': id, [catalogAttributeName]: type };
        const payload = { cabinet_id: id };
        await this.addNonTopoFeatureAction({
          datasource: addedDatasource,
          body: payload,
          params: {
            layer_id: this.layersIdDict[addedDatasource],
          },
        });
        await this.init(this.featureId, true);
        this.clearMainDialog();
      } catch (error) {
        this.clearMainDialog();
        console.log('  error', error);
      }
    },
    clearMainDialog() {
      this.mainDialogButtonLoading = false;
      this.isMainDialogVisible = false;
      this.addedObject.type = undefined;
    },
    pushToParentRoute() {
      this.$router.push({
        name: this.$route.meta.parent,
        params: {
          ...this.$route.params,
          lid: this.layerId,
        },
      });
      this.currentTab = 0;
    },
    refreshLayersAndTable(layers) {
      this.$root.$emit('refreshTableData');
      this.$root.$emit(
        'refreshMvtSources',
        layers.map(layer => ({ id: layer, group: 'layers' })),
        true
      );
      this.$root.$emit('updateLegendStylesCounts', { layersIds: layers });
    },
    onDelete(id, datasource) {
      this.dialogType = 'delete';
      this.deletedId = id;
      this.deletedDatasource = datasource;
      this.isMainDialogLoaded = true;
      this.isMainDialogVisible = true;
    },
    async deleteObjectHandler() {
      try {
        this.mainDialogButtonLoading = true;
        const { deletedDatasource, deletedId } = this;
        await this.deleteDatasourceFeature({
          datasource: deletedDatasource,
          id: deletedId,
          params: {
            layer_id: this.layersIdDict[deletedDatasource],
          },
        });
        if (this.zdmCabinetDataSourceName === deletedDatasource) {
          this.pushToParentRoute();
          this.refreshLayersAndTable([this.layerId]);
        } else {
          this.activeFeature = `${MAIN_TYPE}@${this.featureId}`;
          await this.init(this.featureId, true);
        }
        this.mainDialogButtonLoading = false;
        this.isMainDialogVisible = false;
      } catch (error) {
        console.log('  error', error);
        this.isMainDialogVisible = false;
        this.mainDialogButtonLoading = false;
      }
    },
    goBack() {
      this.$router.back();
    },
    setFormSchema(layerSchema, metadata, filteredOutAttributes) {
      this.formSchema = this.getForm(layerSchema, metadata, filteredOutAttributes);
    },
    setValues(attributesValues) {
      this.values = this.getValues(this.formSchema, attributesValues);
    },
    setSubfeaturesDict(lamp) {
      this.subfeaturesDict = this.getSubfeaturesDict(lamp, MAIN_TYPE);
    },
    getSubfeaturesDict(object, type) {
      return object.reduce((total, current) => {
        const subfeatureKey = this.subFeaturesNamesDict[type];
        const treeviewId = `${type}@${current.id}`;
        const currentObject = {
          ...current,
          [this.idPropNameDict[this.getDatasource(type)]]: current.id,
          treeviewId,
          type,
          ...current.properties,
        };
        delete currentObject.properties;
        return {
          ...total,
          [treeviewId]: currentObject,
          ...(subfeatureKey ? this.getSubfeaturesDict(current[subfeatureKey], subfeatureKey) : {}),
        };
      }, {});
    },
    setTreeviewStructure(data) {
      this.treeviewStructure = this.getTreeviewStructure(data, MAIN_TYPE);
    },
    getTreeviewStructure(object, type) {
      return object.reduce((total, current) => {
        const subfeatureKey = this.subFeaturesNamesDict[type];
        const datasource = this.getDatasource(type);
        const { id, properties, main } = current;
        const children = subfeatureKey ? this.getTreeviewStructure(current[subfeatureKey], subfeatureKey) : undefined;
        return [
          ...total,
          {
            id,
            type,
            datasource,
            treeviewId: `${type}@${id}`,
            translatedType: this.$i18n.t(`sidebar.zdmCabinet.${type}`),
            displayName: type !== MAIN_TYPE && properties.street,
            displayNumber: type !== MAIN_TYPE && properties[this.displayNameDict[datasource]],
            dotsItems: this.getDotsItems(type, children, main),
            isMain: main || false,
            children,
          },
        ];
      }, []);
    },
    getDotsItems(type) {
      const isCabinet = type === 'cabinet';
      return [
        {
          name: 'edit',
        },
        ...(isCabinet
          ? [
              {
                name: 'addCircuit',
              },
            ]
          : []),
        {
          name: 'delete',
          // disabled: isPickArm && isMain,
          // tooltip: isPickArm && isMain ? this.$i18n.t('sidebar.zdmLamp.mainPickArmDelete') : undefined,
        },
      ];
    },
    getDotsAddItem() {
      return;
    },
    setActiveFeature({ type, id }) {
      if (type && id) {
        this.activeFeature = `${type}@${id}`;
      } else {
        this.activeFeature = `${MAIN_TYPE}@${this.featureId}`;
      }
    },
    getDatasource(type) {
      return `zdm_data_${type}`;
    },
    attachListeners() {
      this.unwatchFeatureId = this.$watch('featureId', nV => {
        this.init(nV, true);
      });
      this.unwatchActiveFeature = this.$watch('activeFeature', nV => {
        const [type, id] = nV.split('@');
        this.setActiveFeatureData(type, id);
        this.$router.push({
          ...this.$route,
          query: {
            ...this.routeQuery,
            type,
            id,
          },
        });
      });
    },
    getAttributesMetadata(datasource) {
      return this.metadata[datasource].attributes_schema.attributes;
    },
    setActiveFeatureData(type, id) {
      this.type = type;
      this.currentObjectId = id;
      const datasource = this.getDatasource(type);
      const attributesMetadata = this.getAttributesMetadata(datasource);
      const currentFeature = this.subfeaturesDict[`${type}@${id}`];
      const layer =
        datasource === this.zdmCabinetDataSourceName ? this.layer : this.layers[this.layersIdDict[datasource]];
      const layerSchema = layer.form_schema.elements;
      const catalogAttributeName =
        datasource !== this.zdmCabinetDataSourceName && this.catalogAttributeNameDict[datasource];
      const filteredAttibutes = catalogAttributeName ? [catalogAttributeName] : undefined;
      this.setFormSchema(layerSchema, attributesMetadata, filteredAttibutes);
      this.setValues(currentFeature);
      // if (datasource !== this.zdmCabinetDataSourceName) {
      //   this.setTypeAttribute({ datasource, layerSchema, catalogAttributeName });
      //   this.setTypeValue(currentFeature, catalogAttributeName);
      // }
    },
    // getTypeAttribute({ datasource, layerSchema, catalogAttributeName }) {
    //   const typeElement = this.$_findObjectInNestedArraysByValue(
    //     layerSchema,
    //     item => item.attribute === catalogAttributeName,
    //     'elements'
    //   );
    //   if (!typeElement) {
    //     return;
    //   }
    //   const preapredAttribute = this.getForm([typeElement], this.getAttributesMetadata(datasource))[0];
    //   delete preapredAttribute.label;
    //   return {
    //     ...preapredAttribute,
    //     name: catalogAttributeName,
    //     translationPath: 'sidebar.type',
    //     outlined: true,
    //     dense: true,
    //     'align-items': 'center',
    //     icon: 'mdi-tag-multiple',
    //     hasDivider: true,
    //   };
    // },
    // setTypeAttribute({ datasource, layerSchema, catalogAttributeName }) {
    //   this.typeAttribute = this.getTypeAttribute({ datasource, layerSchema, catalogAttributeName });
    // },
    // setTypeValue(currentFeature, catalogAttributeName) {
    //   this.values = {
    //     ...this.values,
    //     [catalogAttributeName]: currentFeature[catalogAttributeName],
    //   };
    // },
    onMounted() {
      this.init(this.featureId);
    },
    toggleListeners(isOn) {
      const method = isOn ? '$on' : '$off';
      this.$root[method]('featureEditing', this.editNonTopoFeature);
      this.$root[method]('cancelEditing', this.cancelEditing);
      this.$root[method]('turnOffEditing', this.stopEditing);
      this.$root[method]('tableDataFetched', this.init);
      this.$root[method]('refreshFormData', this.refreshFormData);
    },
    getPayload(type) {
      return {
        ...this.values,
        ...(type === MAIN_TYPE ? { [this.geometryPropertyName]: this.geometry } : {}),
      };
    },
    refreshTableAndMap() {
      this.$root.$emit('refreshTableData');
      this.$root.$emit('refreshMvtSource', this.layerId);
      this.$root.$emit('updateLegendStylesCounts', { layersIds: [this.layerId] });
    },
    async fetchCabinetData(id) {
      try {
        const r = await this.getLampWithObjectsAction({ id, datasource: this.zdmCabinetDataSourceName });
        this.setSubfeaturesDict([r.data.data]);
        this.setTreeviewStructure([r.data.data]);
        this.feature = {
          ...r.data.data,
          [this.idPropNameDict[this.zdmCabinetDataSourceName]]: r.data.data.id,
        };
        this.geometry = r.data.data.geometry;
      } catch (error) {
        console.log('  error', error);
      }
    },
    refreshFormData() {
      this.init(this.featureId, true);
    },
    async init(id = this.featureId, isSkipMetadataFetching) {
      if (!this.mapPanelDataFetched) {
        return;
      }
      try {
        this.clearHighlitedFeature(this.layerId);
        this.isLoading = true;
        await Promise.all([
          this.fetchCabinetData(id),
          ...(isSkipMetadataFetching
            ? []
            : this.subDataSources.map(
                async subDatasource =>
                  await this.fetchData(
                    subDatasource,
                    this.layers[this.layersIdDict[subDatasource]].form_schema.elements
                  )
              )),
        ]);
        const type = this.routeQuery?.type || MAIN_TYPE;
        const objectId = this.routeQuery?.id || id;
        this.type = type;
        this.currentObjectId = objectId;
        this.setActiveFeatureData(type, objectId);
        this.highlightFeature(this.layerId, this.feature.id);
        this.setActiveFeature(this.routeQuery);
        if (!isSkipMetadataFetching) {
          this.attachListeners();
        }
        this.isLoading = false;
        if (this.isNewCard) {
          this.isNewCard = false;
          const { crs } = this.geometry;
          this.$root.$emit('createGeomAndFitView', { ...this.geometry, crs });
        }
      } catch (error) {
        console.log('  error', error);
      }
    },
  },
  mounted() {
    this.onMounted();
    this.toggleListeners(true);
    this.$once('hook:beforeDestroy', () => {
      this.clearHighlitedFeature(this.layerId);
      this.unwatchFeatureId?.();
      this.unwatchActiveFeature?.();
      this.toggleListeners(false);
    });
  },
};
</script>

<style lang="scss" scoped></style>
